import React, { useState } from 'react';
import { Form, Input, Button, message } from 'antd';
import { equipamentosService } from '../../services/api';

const StepGrid = ({ siteId, currentStep, totalSteps, onPrev, onNext }) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [saved, setSaved] = useState(false);

    const handleSave = async () => {
        if (!siteId) {
            message.error('Selecione ou salve um site no passo anterior.');
            return;
        }
        try {
            setLoading(true);
            await form.validateFields();
            const values = form.getFieldsValue();
            const payload = {
                name: `Grid - ${values.concessionaria || 'Rede'}`,
                type: 'GRID',
                status: 'CONECTADO',
                siteId,
                concessionaria: values.concessionaria || null,
                numeroInstalacao: values.numeroInstalacao || null,
                serialNumber: values.numeroInstalacao || null,
            };
            const res = await equipamentosService.create(payload);
            const equipment = res?.data ?? res;
            if (equipment?.id) {
                message.success('Grid cadastrado com sucesso!');
                setSaved(true);
            }
        } catch (error) {
            message.error(error.response?.data?.message || 'Erro ao salvar Grid.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{ padding: 24, backgroundColor: 'white' }}>
            <h2 style={{ color: '#2957A4', marginBottom: 16 }}>Grid (Rede Elétrica)</h2>
            <Form form={form} layout="vertical">
                <Form.Item name="concessionaria" label="Concessionária" rules={[{ required: true }]}>
                    <Input placeholder="Ex: ENEL SP, CPFL" />
                </Form.Item>
                <Form.Item name="numeroInstalacao" label="Número da Instalação" rules={[{ required: true }]}>
                    <Input placeholder="Número da unidade consumidora" />
                </Form.Item>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 24, gap: 8 }}>
                    {currentStep > 0 && <Button onClick={onPrev}>Voltar</Button>}
                    <div style={{ marginLeft: 'auto', display: 'flex', gap: 8 }}>
                        {currentStep < totalSteps - 1 && (
                            <Button onClick={onNext} disabled={!saved}>Próximo</Button>
                        )}
                        <Button type="primary" onClick={handleSave} loading={loading} style={{ backgroundColor: '#2957A4', borderColor: '#2957A4' }}>
                            Salvar
                        </Button>
                    </div>
                </div>
            </Form>
        </div>
    );
};

export default StepGrid;
